module.exports = __webpack_public_path__ + "img/HC3P_Carrousel_6.2ea55d2e.jpg";